import { useTranslation } from 'react-i18next';
import type { IBriefingListProps } from './IBriefingListProps';

/** «Підготовчі завдання» (прототип v4 ivTasks): ✓ — виконане, ○ — ні; назва; праворуч «вид · статус». */
export function BriefingTasks({ items, labels, onOpen }: IBriefingListProps) {
  const { t } = useTranslation();
  return (
    <section className="viz-card">
      <div className="viz-card__title">{t('recordPage.viz.briefing.tasks')}</div>
      {items.map((r) => (
        <button key={r.id} type="button" className="viz-item viz-item--task" onClick={() => onOpen(r)}>
          <span className="viz-item__mark" aria-hidden>{r.isClosed ? '✓' : '○'}</span>
          <span className="viz-item__text">{r.title || r.display}</span>
          <span className="viz-item__meta viz-item__nowrap">{[labels.option('ptype', r.values['ptype']), labels.status(r.status)].filter(Boolean).join(' · ')}</span>
        </button>
      ))}
    </section>
  );
}
